import { Component } from "@angular/core";
import { NewDistilleryPage } from "../newDistillery/newDistillery";
import { Events } from "ionic-angular";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { WhiskyDB } from "../../data/db";
import { SublistPage } from "../sublist/sublist";
import { ModalController } from "ionic-angular/components/modal/modal-controller";

@Component({
  selector: "page-distilleries",
  templateUrl: "distilleries.html"
})
export class DistilleriesPage {
  newDistilleryPage: any;
  sublistPage: any;

  constructor(
    public events: Events,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {
    this.initializeItems();
    this.newDistilleryPage = NewDistilleryPage;
    this.sublistPage = SublistPage;

    // Update event
    this.events.subscribe("distilleries:updated", () => {
      console.log("Got distilleries:updated event");
      // Reapply fiters
      this.getItems(this.lastFilter);
    });

    this.events.subscribe("distilleries:save", () => {
      console.log("Got distilleries:save event");
      WhiskyDB.db.saveDistilleries();
    });

    this.events.subscribe("distilleries:add", (dist, reg) => {
      console.log("Got distilleries:add event");
      WhiskyDB.distilleries.push({ Distillery: dist, Region: reg });
      this.events.publish("distilleries:save");
      this.events.publish("distilleries:updated");
    });
  }

  searchQuery: string = "";
  items: any[];
  lastFilter: any = null;

  ionViewWillEnter() {
    if (this.allItems.length == 0) {
      this.initializeItems();
    }
  }

  initializeItems() {
    // Initial list is unfiltered
    this.getItems(null);
  }

  limit = 20;

  getItems(ev: any) {
    // Sve the filter
    this.lastFilter = ev;
    this.limit = 20;
    this.getMoreItems(ev);
  }

  allItems: any[];

  getMoreItems(ev: any) {
    // set val to the value of the searchbar
    let val = "";
    if (ev != null) {
      val = ev.target.value;
    }
    console.log("Getting " + this.limit + " items");

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      this.allItems = WhiskyDB.distilleries.filter(item => {
        //console.log(item)
        if (item.SMWS == null) {
          item.SMWS = ""
        }
        return (
          item.Distillery.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.Region.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.SMWS.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    } else {
      // Reset items back to all of the items
      this.allItems = WhiskyDB.distilleries;
    }

    // Get initial chunk from filtered items
    this.items = this.allItems.slice(
      0,
      Math.min(this.limit, this.allItems.length)
    );
  }

  doInfinite(event: any) {
    //console.log("doInfinite");
    // Get next chunk from all filtered & sorted items
    let prior = this.limit;
    this.limit = this.limit + 20;
    //console.log("get more items: " + this.limit);
    this.limit = Math.min(this.limit, this.allItems.length);
    let moreItems = this.allItems.slice(prior, this.limit);

    moreItems.forEach(i => {
      this.items.push(i);
    });

    event.complete();
  }

  remove(toRemove: any, slider: any) {
    slider.close();
    let alert = this.alertCtrl.create({
      title: "Remove Distillery?",
      subTitle: toRemove.Distillery,
      cssClass: "removeAlert",
      buttons: [
        {
          text: "Cancel",
          role: "Cancel",
          handler: () => {
            console.log("Cancel remove");
          }
        },
        {
          text: "Remove",
          cssClass: "remove-button",
          handler: () => {
            // Remove selected items
            console.log("Remove: " + toRemove.Distillery);
            // Remove is via a filter
            WhiskyDB.distilleries = WhiskyDB.distilleries.filter(item => {
              return item.Distillery !== toRemove.Distillery;
            });

            // Save them
            this.events.publish("distilleries:save");
            this.events.publish("distilleries:updated");
          }
        }
      ]
    });
    alert.present();
  }

  select(item) {
    console.log("Viewing : " + item.Distillery, item);
    let modal = this.modalCtrl.create(this.sublistPage, {
      title: item.Distillery,
      type: "distillery",
      distillery: item,
      URL: item.URL
    });
    modal.present();

    //this.navCtrl.push(this.sublistPage, {title: item.Distillery, type: "distillery", distillery: item})
  }
}



// WEBPACK FOOTER //
// ./src/pages/distilleries/distilleries.ts